<template>
  <section class="content">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">New Multi-family Evaluation</p>
      </header>
      <section class="modal-card-body">

        <p>Select the evaluation to create...</p>
        <table>
          <tr>
            <td><span
                class="button is-link is-fullwidth"
                @click="newBPO()"
              >MFQA 1</span>
            </td>
            <td>Create a new MFQA 1. This is a 'back of the napkin' evaluation and intended to be quick. Do it before touring the property.</td>
          </tr>

          <tr>
            <td><span
                class="button is-link is-fullwidth"
                @click="newBPO2()"
              >MFQA 2</span>
            </td>
            <td>Create a new MFQA 2 from scratch. This evaluation includes the 9 expense categories from NAA. Do it after your LOI is accepted.</td>
          </tr>

        </table>

      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-primary"
          type="button"
          @click="$parent.close()"
        >Close</button>
      </footer>
    </div>
  </section>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {
    async newBPO() {
      console.log("newBPO()");
      var propertyId = this.$store.state.property.id;
      await this.$store.dispatch("createBPO", propertyId);
      this.$router.push({
        name: "BPO",
        params: {
          property_id: this.$store.state.bpo.propertyId,
          bpo_id: this.$store.state.bpo.id
        }
      });
    },

    async newBPO2() {
      var propertyId = this.$store.state.property.id;
      await this.$store.dispatch("createBPO2FromScratch", propertyId);
      this.$router.push({
        name: "BPO2",
        params: {
          property_id: this.$store.state.bpo2.propertyId,
          bpo2_id: this.$store.state.bpo2.id
        }
      });
    },

    async newLongFormFromScratch() {
      var propertyId = this.$store.state.property.id;
      await this.$store.dispatch("createLongFormFromScratch", propertyId);
      this.$router.push({
        name: "LongForm",
        params: {
          property_id: this.$store.state.longform.propertyId,
          bpo2_id: this.$store.state.longform.id
        }
      });
    }
  },
  mounted() {}
};
</script>

<style>
</style>
